import { BreakLine, Card, CardSectionHeader, CheckPoint, ConnectingCheckPoints, Loader } from "@egovernments/digit-ui-react-components";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import BPADocuments from "./BPADocuments";
import TLCaption from "./TLCaption";
import FormSummary from "../../Forms/FormSummary";
import EmpMapSubmissionPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpMapSubmissionPortal";
import EmpLandUsePortal from "@egovernments/digit-ui-module-obps/src/pages/employee/LandUseVerification&NOC/EmpLandUsePortal";
import EmpPurchasableFarPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/PurchasableFaRNewDesign/EmpPurchasableFarPortal";
import RevalMapSubmissionPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/RevalMapSubmissionPortal";
import EmpNOCPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/NOC/EmpNOCPortal";
import EmpPlinthPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpPlinthPortal";
import EmpKYPPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/LandUseVerification&NOC/EmpKYPPortal";
import EmpSelfRegistration from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpSelfRegistration";
import EmpSelfApproval from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpSelfApproval";
import EmpMapPurchasablePortal from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpMapPurchasablePortal";
import EmpCompoundingPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpCompoundingPortal";
import EmpCompletionPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/MapSubmission/EmpCompletionPortal";
import EmpLandUseConversionPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/LandUseConversion/EmpLandUseConversionPortal";
import EmpFormSuggestionPortal from "@egovernments/digit-ui-module-obps/src/pages/employee/EmpFormSuggestion/EmpFormSuggestionPortal";

function ApplicationDetailsContentForm11({
  applicationDetails,
  isLoading,
  setOnAddComments,
  workflowDetails,
  isDataLoading,
  applicationData,
  refetch,
  timelineStatusPrefix,
  showTimeLine = true,
  onActionSelect,
  forcedActionPrefix,
  submitAction,
  actionData,
  moduleCode,
  businessService,
  action,
  statusAttribute = "status",
  formType,
  userRolesArray,
  workflow,
  isFromDashboard,
}) {
  const { t } = useTranslation();

  function OpenImage(imageSource, index, thumbnailsToShow) {
    window.open(thumbnailsToShow?.fullImage?.[0], "_blank");
  }
  console.log("loggingFormTypeFromAppForm!!", formType, applicationDetails, isFromDashboard);

  const getTimelineCaptions = (checkpoint) => {
    if (checkpoint.state === "OPEN" || (checkpoint.status === "INITIATED" && !window.location.href.includes("/obps/"))) {
      const caption = {
        date: Digit.DateUtils.ConvertTimestampToDate(applicationData?.auditDetails?.createdTime),
        source: applicationData?.channel || "",
      };
      return <TLCaption data={caption} />;
    } else if (window.location.href.includes("/obps/") || window.location.href.includes("/noc/")) {
      const caption = {
        date: checkpoint?.auditDetails?.lastModified,
        name: checkpoint?.assignes?.[0]?.name,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
        comment: t(checkpoint?.comment),
        wfComment: checkpoint.wfComment,
        thumbnailsToShow: checkpoint?.thumbnailsToShow,
      };
      return <TLCaption data={caption} OpenImage={OpenImage} />;
    } else {
      const caption = {
        date: Digit.DateUtils?.ConvertTimestampToDate(applicationData?.auditDetails?.lastModifiedTime),
        name: checkpoint?.assignes?.[0]?.name,
        wfComment: checkpoint?.wfComment,
        mobileNumber: checkpoint?.assignes?.[0]?.mobileNumber,
      };
      return <TLCaption data={caption} />;
    }
  };
  return (
    <Card className={"employeeCard-override"}>
      {isLoading ? (
        <Loader />
      ) : (formType === "MAP_SUB" && applicationDetails?.applicationType === "FORM_PLINTH") ||
        (isFromDashboard && applicationDetails?.applicationType === "FORM_PLINTH") ? (
        <EmpPlinthPortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "FORM_PRESSRELEASE" && applicationDetails?.applicationType === "FORM_PRESSRELEASE") ||
        (isFromDashboard && applicationDetails?.applicationType === "FORM_PRESSRELEASE") ? (
        <EmpFormSuggestionPortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "FORM_LANDUSECONVERSION" && applicationDetails?.applicationType === "FORM_LANDUSECONVERSION") ||
        (isFromDashboard && applicationDetails?.applicationType === "FORM_LANDUSECONVERSION") ? (
        <EmpLandUseConversionPortal
          formData={applicationData}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "MAP_SUB" && applicationDetails?.applicationType === "FORM_PURCHASABLE_FAR") ||
        (isFromDashboard && applicationDetails?.applicationType === "FORM_PURCHASABLE_FAR") ? (
        <EmpMapPurchasablePortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          urlFormType={formType}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "MAP_SUB" && applicationDetails?.applicationType === "FORM_COMPLETION") ||
        (isFromDashboard && applicationDetails?.applicationType === "FORM_COMPLETION") ? (
        <EmpCompletionPortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          urlFormType={formType}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "MAP_SUB" && applicationDetails?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts") ||
        applicationDetails?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm" ||
        (isFromDashboard &&
          (applicationDetails?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
            applicationDetails?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm")) ? (
        <EmpSelfApproval
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "MAP_SUB" && applicationDetails?.planOn === "SELF_MAP") || (isFromDashboard && applicationDetails?.planOn === "SELF_MAP") ? (
        <EmpSelfRegistration
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "MAP_SUB" && applicationDetails?.natureOfConstruction === "Compounding") ||
        (isFromDashboard && applicationDetails?.natureOfConstruction === "Compounding") ? (
        <EmpCompoundingPortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : formType === "MAP_SUB" ||
        (formType === "FORM_MAP" && applicationDetails?.land_Id) ||
        (isFromDashboard && applicationDetails?.land_Id && applicationDetails?.applicationType === "FORM_MAP") ? (
        <EmpMapSubmissionPortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          urlFormType={formType}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "MAP_SUB" && !applicationDetails?.land_Id) ||
        (isFromDashboard && !applicationData?.land_Id && applicationDetails?.applicationType === "FORM_MAP") ? (
        <RevalMapSubmissionPortal
          formData={applicationDetails}
          refetch={refetch}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : (formType === "formLandUse" && applicationDetails?.applicationType === "FORM_KYP") ||
        (isFromDashboard && applicationData?.applicationType === "FORM_KYP") ? (
        <EmpKYPPortal
          formData={applicationData}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : formType === "formLandUse" || (isFromDashboard && applicationData?.applicationType === "FORM_LANDUSE") ? (
        <EmpLandUsePortal
          formData={applicationData}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          isFromDashboard={isFromDashboard}
        />
      ) : formType === "PURCHASABLE_FAR" ? (
        <EmpPurchasableFarPortal
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          workflow={workflow}
          formData={applicationData}
          isFromDashboard={isFromDashboard}
        />
      ) : formType === "NOC" ? (
        <EmpNOCPortal
          formData={applicationDetails}
          submitAction={submitAction}
          workflowDetails={workflowDetails}
          userRolesArray={userRolesArray}
          urlFormType={formType}
        />
      ) : (
        <FormSummary
          onActionSelect={onActionSelect}
          setOnAddComments={setOnAddComments}
          formData={applicationDetails}
          showTimeLine={showTimeLine}
          workflowDetails={workflowDetails}
          timelineStatusPrefix={timelineStatusPrefix}
          isDataLoading={isDataLoading}
          forcedActionPrefix={forcedActionPrefix}
          submitAction={submitAction}
          actionData={actionData}
          moduleCode={moduleCode}
          applicationData={applicationData}
          action={action}
          businessService={businessService}
        />
      )}

      {!applicationDetails?.documents && (
        <BPADocuments t={t} applicationData={applicationDetails} docs={applicationDetails?.documents} bpaActionsDetails={workflowDetails} />
      )}
    </Card>
  );
}

export default ApplicationDetailsContentForm11;
